import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext } from 'react';
import CarouselAnalytics, {
  INTERACTION_TO_ACTION
} from '~/constants/common/CarouselAnalytics';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';

export default function useCarouselAnalytics() {
  const { analyticsAttributes, analyticsId } = useSectionAnalytics();
  const { trackEvent } = useContext(AnalyticsContext);

  return useCallback(
    ({ event, location }: CarouselAnalytics) => {
      if (analyticsId) {
        trackEvent(analyticsId, {
          ...analyticsAttributes,
          action: INTERACTION_TO_ACTION[event.interactionType],
          direction: event.direction,
          location
        });
      }
    },
    [analyticsAttributes, analyticsId, trackEvent]
  );
}
